import { useNavigate } from "react-router-dom";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { User, UserCheck, Users } from "lucide-react";
import { APP_ROUTES } from "../../routes";

const CreateVisitRequest = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleNavigation = useCallback(
    (path: string) => {
      navigate(path);
    },
    [navigate]
  );

  const applyForItems = useMemo(
    () => [
      {
        id: 1,
        title: t("individual"),
        url: APP_ROUTES.INDIVIDUAL_VISIT_REQUEST,
        Icon: <User color="white" size={80} />,
      },
      {
        id: 2,
        title: t("group"),
        url: APP_ROUTES.GROUP_VISIT_REQUEST,
        Icon: <Users color="white" size={80} />,
      },
      {
        id: 3,
        title: t("vipVvip"),
        url: APP_ROUTES.VIP_VISIT_REQUEST,
        Icon: <UserCheck color="white" size={80} />,
      },
    ],
    [t]
  );

  return (
    <div className="flex flex-col gap-4 items-center mx-auto lg:w-3/4">
      <p className="text-center lg:text-lg font-medium dark:text-white">
        {t("visitorPassRequest")}
        <br />
        <span className="font-normal">{t("pleaseTakeMoment")}</span>
      </p>

      <div className="bg-white py-2 px-3 lg:p-6 rounded-xl flex flex-col gap-4 lg:gap-8 items-start justify-center w-full">
        <p className="text-lg lg:text-xl font-medium">
          {t("applyingVisitFor")}
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-6 w-full px-4">
          {applyForItems.map((item) => (
            <div
              key={item.id}
              className="flex flex-col gap-3 w-full cursor-pointer "
              onClick={() => item.url && handleNavigation(item.url)}
            >
              <div
                key={item.id}
                className="bg-purple-primary/30 px-4 h-[30vh] rounded-lg flex items-center justify-center hover:ring-2 hover:ring-purple-primary hover:scale-105 transition-transform duration-200 ease-in-out"
              >
                {item.Icon}
              </div>
              <p className="text-center">{item.title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CreateVisitRequest;
